const isUrlValid = function (route, url) {
  const regex = new RegExp(`organizations/\\d+/${route}`);

  return regex.test(url);
}

export const replaceTabUrl = function (route) {
  if (typeof Storage !== 'undefined') {
    const tab = document.querySelector(`#${route}_tab`);
    const organizationId = document.body.dataset.organizationId;
    const currentUserDetails = document.body.dataset.currentUserDetails;
    let userId;

    if (currentUserDetails) {
      try {
        userId = JSON.parse(currentUserDetails).id;
      } catch (e) {
        console.log(e.message);
      }
    }
    if (tab && organizationId && userId) {
      const url = localStorage.getItem(`${route}_url_org_${organizationId}_user_${userId}`);

      if (url && isUrlValid(route, url)) {
        tab.href = url;
      }
    }
  }
}

export const savePageFiltersToLocalStorage = function ({
  organizationId,
  userId,
  route,
  onlyParams = [],
  exceptParams = [], // ignored if onlyParams isn't empty
  urlString = window.location.href,
}) {
  if (typeof Storage !== 'undefined') {
    if (organizationId && userId && isUrlValid(route, urlString)) {
      const url = new URL(urlString);
      let excludedKeys = exceptParams;

      if (onlyParams.length) {
        excludedKeys = Array.from(url.searchParams.keys()).filter((key) => !onlyParams.includes(key));
      }
      excludedKeys.forEach((key) => url.searchParams.delete(key));

      localStorage.setItem(
        `${route}_url_org_${organizationId}_user_${userId}`,
        url.toString(),
      );

      // update respective link(s) in the sidebar
      const sidebar = document.querySelector('div.hotwired-sidebar') || document.querySelector('div.nav-sidebar');

      if (sidebar) {
        const links = Array.from(sidebar.querySelectorAll('a'));
        const sidebarItems = {
          time_entries: ['scheduleTimesheets', 'View & edit'],
          timesheets: ['Approvals'],
          schedules: ['calendar_todayCalendar', 'Schedules'],
        }

        sidebarItems[route]?.forEach((name) => {
          links.filter((el) => el.textContent === name).forEach((linkEl) => {
            linkEl.href = url.toString();
          });
        });
      }
    }
  }
}
